import React, { useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";

import {
  HubButton,
  HubHookFormWorkOrderSelect,
  WorkOrderRoutingSelect,
} from "../../components";
import { useGetWorkOrderRouting, useHubSnackBar } from "../../hooks";

import CreateLaborContentEmployeeId from "./CreateLaborContentEmployeeId";

const CreateLaborForm = ({ workOrder, rid, onClose = () => {} }) => {
  const { watch } = useFormContext();

  const workOrderId = watch("workOrder") || workOrder;

  const { data, isError } = useGetWorkOrderRouting(workOrderId);
  const { addSnackbarError } = useHubSnackBar();

  useEffect(() => {
    if (isError) {
      addSnackbarError({
        title: "Error Retrieving Work Order",
        message: "Please confirm the work order is valid",
      });
      onClose();
    }
  }, [isError]);

  return (
    <Stack gap="15px" width="100%" alignItems="center">
      {!workOrder && <HubHookFormWorkOrderSelect />}
      <Stack direction="row" gap="15px" width="100%">
        <WorkOrderRoutingSelect
          routeId={rid}
          workOrder={workOrderId}
          includeSubRoutes
          showScrollbar
        />
        <CreateLaborContentEmployeeId locationId={data?.locationId} />
      </Stack>
      {workOrderId ? (
        <HubButton
          size="small"
          label={`View ${workOrderId}`}
          variant="text"
          page={`/works/${workOrderId}`}
          onClick={onClose}
        />
      ) : (
        <Box sx={{ height: "12px" }} />
      )}
    </Stack>
  );
};

export default CreateLaborForm;
